module.exports = __webpack_public_path__ + "3e1c55a927fd099eefbcf14cda45b408.jpg";